/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/plus': {
    width: 35,
    height: 35,
    viewBox: '0 0 35 35',
    data: '<path pid="0" _fill="#000" d="M0 15h35v6H0z"/><path pid="1" _fill="#000" d="M14 35V0h6v35z"/>'
  }
})
